import { useState } from "react";
import { BaseButton, BaseInput } from "../../components/base";
import { useNotification } from "../../context/NotificationProvider";
import { register } from "../../api/auth/authAPI";
import { Box, Typography, Checkbox, useTheme } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import logo from "../../assets/images/hashinLogoLight.png";
import URIs from "../../utils/uri";

const Register = () => {
  const [phoneValue, setPhoneValue] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const {showNotification} = useNotification();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true);

    try {
      await register(phoneValue);
      navigate(URIs.VERIFY, { state: { phoneValue } })
    } catch (error) {
        showNotification(error, 'error')
    } finally {
      setIsloading(false);
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const openLogin = () =>  {
    navigate(URIs.LOGIN)
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flexStart"
      alignItems="center"
      padding={2}
      gap={4}
      sx={{ height: "100vh", paddingTop: "80px"}}
    >
      <img
        src={logo}
        alt="Logo"
        style={{ width: "120px"}}
      />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        style={{ width: "90%", maxWidth: 400 }}
        gap={2}
      >
        <Typography variant="title">هاشین گلد</Typography>
        <Typography variant="subtitle" sx={{ textAlign: 'center' }}>
          برای ساخت حساب کاربری و شروع خرید و فروش آنلاین طلا، شماره موبایل خود را وارد کنید
        </Typography>
      </Box>
      <form onSubmit={handleSubmit} style={{ width: "90%", maxWidth: 400 }}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="stretch"
          gap={2}
        >
          <BaseInput
            label="شماره موبایل"
            value={phoneValue}
            onChange={(e) => setPhoneValue(e.target.value)}
            name="username"
            type="number"
            autoComplete="username"
          />
          <Box 
            display="flex"
            flexDirection="row"
            justifyContent="flexStart"
            alignItems="center"
            gap={1}
          >
            <Checkbox
              checked={isChecked}
              onChange={handleCheckboxChange}
              name="acceptTerms"
            />
            <Typography variant="subtitle">
            <span>
              <Link
                to="https://hashingold.com/terms-and-services"
                style={{ textDecoration: 'underline', color: theme.palette.primary.main }}
                target="_blank"
                rel="noopener noreferrer"
              >
                قوانین و شرایط
              </Link>
              {' '}  معامله در سامانه هاشین گلد را میپذیرم.
            </span>
            </Typography>
          </Box>
          <BaseButton
            type="submit"
            isLoading={isLoading}
            disabled={!isChecked}
          >
            ثبت نام
          </BaseButton>
        </Box>
      </form>
	    <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        gap={2}
      >
        <Typography variant="subtitle">قبلا ثبت نام کرده‌اید؟</Typography>
		    <Typography variant="subtitle" color='textDark' onClick={openLogin} sx={{ cursor: 'pointer' }}>
          وارد شوید 
        </Typography>
      </Box>
    </Box>
  );
};

export default Register;
